package core.config

import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue

object FeatureConfig {
    var hasWhatsapp by mutableStateOf(false)
        private set

    var hasQuickBooks by mutableStateOf(false)
        private set

    var hasConcierge by mutableStateOf(false)
        private set

    var hasCrm by mutableStateOf(false)
        private set

    var hasHome by mutableStateOf(false)
        private set

    var hasItineraries by mutableStateOf(false)
        private set

    var hasProposals by mutableStateOf(false)
        private set

    var hasServices by mutableStateOf(false)
        private set

    var hasTasks by mutableStateOf(false)
        private set

    var hasDynamicPricing by mutableStateOf(false)
        private set

    fun update(values: List<String>) {
        hasWhatsapp = values.contains("whatsapp")
        hasQuickBooks = values.contains("quickbooks")
        hasConcierge = values.contains("concierge")
        hasCrm = values.contains("crm")
        hasHome = values.contains("home")
        hasItineraries = values.contains("itineraries")
        hasProposals = values.contains("proposals")
        hasServices = values.contains("services")
        hasTasks = values.contains("tasks")
        hasDynamicPricing = values.contains("dynamic_pricing")
    }
}